<svg data-testid="connection">
    <path [attr.d]="path" />
</svg>
